import { z } from 'zod';

import { type ValidationMessageSet } from '../../form-validations';
import { getCaptchaTokenSchema } from '../../schemas/captcha-token-schema';
import { getEmailSchema } from '../../schemas/email-schema';

type Messages = {
  emailValidationMessages: ValidationMessageSet;
  submitError: string;
};

// Validation for client form only
export const getNurturingSchema = (messages: Messages) =>
  getCaptchaTokenSchema({ requiredMessage: messages.submitError }).merge(
    getEmailSchema(messages.emailValidationMessages)
  );

// Validation for client form only
export const getNurturingNewsletterSchema = (messages: Messages) =>
  z
    .object({
      newsletter: z.boolean(),
    })
    .merge(getNurturingSchema(messages))
    .required();

type BlogAdMessages = Messages & {
  legalValidationMessages: Pick<ValidationMessageSet, 'requiredMessage'>;
};

// Validation for client form only
export const getBlogAdSchema = (messages: BlogAdMessages) =>
  z
    .object({
      legal: z.literal<boolean>(true, {
        errorMap: () => ({
          message: messages.legalValidationMessages.requiredMessage,
        }),
      }),
    })
    .merge(getNurturingSchema(messages))
    .required();
